import { certaintyButton } from './certainty-button';
export const certaintyButtons = (appraisal) => {
    const result = document.createElement('certainty-buttons');
    result.className = 'certainty-buttons';
    result.append(certaintyButton('0.1', appraisal), certaintyButton('0.3', appraisal), certaintyButton('0.6', appraisal), certaintyButton('1.0', appraisal));
    return result;
};
